import tw from "twin.macro";
export const PrimaryButton = tw.button`px-8 py-3  text-xl font-serif font-medium  rounded-xl bg-gray-200 text-gray-700 hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline focus:outline-none transition duration-300`;
